import script from "./SetupChecklist.vue?vue&type=script&setup=true&lang=js"
export * from "./SetupChecklist.vue?vue&type=script&setup=true&lang=js"

import "./SetupChecklist.vue?vue&type=style&index=0&id=87d6ca14&scoped=true&lang=css"

import exportComponent from "/Users/tannerwelton/Development/zulu-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87d6ca14"]])

export default __exports__